import M2wApi from "@/services/m2w_api";

export default class EventsService {
  static async getEvents(lang) {
    return await M2wApi.get_project_events(lang);
  }

  static filterByMonth(events, monthKey) {
    return events.filter((event) => {
      return event.date_from && event.date_from.startsWith(monthKey);
    });
  }
}